"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { UploadTask } from "@/utils/UploadManager";
import { Component, Vue, Ref, PropSync } from "vue-property-decorator";
let UploadEnclosure = class extends Vue {
  constructor() {
    super(...arguments);
    //upload上传框
    this.uploadManager = this.$store.state.uploadManager;
    //任务管理器实例
    this.uploadVDManager = this.$store.state.uploadVDManager;
    //上传任务管理器
    this.shopId = "";
  }
  // 店铺id
  //打开文件框
  openUpload() {
    this._input.click();
  }
  //开始文件上传流程
  submitUpload() {
    let fileList = this._input.files;
    if (fileList.length == 0) {
      return false;
    }
    const tasks = [].map.call(fileList, (item) => {
      return new UploadTask(item, this.shopId, this.type);
    });
    if (this.type === "vd") {
      this.uploadVDManager.add(tasks);
    } else {
      this.uploadManager.add(tasks);
    }
    this.emptyFile();
  }
  //清空file文件数据
  emptyFile() {
    this._input.files = null;
    this._input.type = "text";
    this._input.type = "file";
  }
};
__decorateClass([
  PropSync("uploadType", { type: String })
], UploadEnclosure.prototype, "type", 2);
__decorateClass([
  Ref("input")
], UploadEnclosure.prototype, "_input", 2);
UploadEnclosure = __decorateClass([
  Component({})
], UploadEnclosure);
export {
  UploadEnclosure as default
};
